export default __webpack_public_path__ + "static/media/Info.23bddef8.svg";